<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>
    <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showApiTokenUsage"
      >
        <i
          v-tooltip.bottom.hover="$t('API_TOKENS_USAGE_DETAILS')"
          class="typcn typcn-document-text"
          aria-hidden="true"
        />
        <span
          v-t="'API_TOKENS_USAGE_DETAILS'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <div class="action-icon">
      <button
        class="btn btn-list-function"
        :disabled="disabled"
        @click="deleteApiToken"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </button>
    </div>
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'ApiTokenActions',
  props:{
    currentApiToken: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    deleteApiToken() {
      this.$emit('deleteApiToken', this.currentApiToken);
    },
    showApiTokenUsage() {
      this.$emit('showApiTokenUsage', this.currentApiToken.tokenId);
    },
    collapseActions() {
      this.$emit('collapseActions', this.currentApiToken.tokenId);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>